import * as React from 'react';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Translate } from '../../../../../shared/LanguageService';
import { BrokerAgent, BrokerFirm } from '../types';

type SelectBrokerStepProps = {
    brokerAgents: BrokerAgent[];
    brokerFirms: BrokerFirm[];
    brokerAgentId: number | null;
    brokerFirmId: number | null;
    connectedContentProviderName: string | null;
    onBrokerAgentChange: (brokerAgentId: number) => void;
    onBrokerFirmChange: (brokerFirmId: number) => void;
};

function firmLabel(firm: BrokerFirm): string {
    return firm.isHeadQuarter
        ? `${firm.name} (${Translate('orders/create/form/head-office')})`
        : firm.name;
}

export function SelectBrokerStep({
    brokerAgents,
    brokerFirms,
    brokerAgentId,
    brokerFirmId,
    connectedContentProviderName,
    onBrokerAgentChange,
    onBrokerFirmChange
}: SelectBrokerStepProps) {
    return (
        <>
            <Paper variant="outlined" sx={{ padding: '16px', display: 'grid', gap: '16px' }}>
                <Typography component="h2" sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                    {Translate('order/create/v2/step/broker/orderer')}
                </Typography>
                <TextField
                    id="create-order-broker-agent"
                    select
                    required
                    fullWidth
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                    label={Translate('orders/create/form/order-agent-selection')}
                    value={brokerAgentId === null ? '' : String(brokerAgentId)}
                    disabled={brokerAgents.length < 2}
                    onChange={(event) => onBrokerAgentChange(Number(event.target.value))}
                >
                    {brokerAgents.map((agent) => (
                        <option key={agent.id} value={agent.id}>
                            {agent.name}
                        </option>
                    ))}
                </TextField>
                <TextField
                    id="create-order-broker-firm"
                    select
                    required
                    fullWidth
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                    label={Translate('orders/create/form/order-firm-selection')}
                    value={brokerFirmId === null ? '' : String(brokerFirmId)}
                    disabled={brokerFirms.length < 2}
                    onChange={(event) => onBrokerFirmChange(Number(event.target.value))}
                >
                    {brokerFirms.map((firm) => (
                        <option key={firm.id} value={firm.id}>
                            {firmLabel(firm)}
                        </option>
                    ))}
                </TextField>
            </Paper>
            {connectedContentProviderName && (
                <Alert severity="success" sx={{ marginTop: '16px', fontSize: '14px' }}>
                    {Translate('order/create/v2/connected-to', {
                        contentprovider: connectedContentProviderName
                    })}
                </Alert>
            )}
        </>
    );
}
